import { useRuntimeConfig } from '#app'

let MAIN_CREDIT_UNIT = ''
try {
  const runtimeConfig = useRuntimeConfig()
  MAIN_CREDIT_UNIT = runtimeConfig.public.MAIN_CREDIT_UNIT
  // eslint-disable-next-line no-empty
} catch {}

export const validateMessage = {
  minAmountDeposit: `Số tiền nạp tối thiểu là \${min} ${MAIN_CREDIT_UNIT}.`,
  maxAmountDeposit: `Số tiền nạp tối đa là \${max} ${MAIN_CREDIT_UNIT}.`,
  minAmountWithDraw: `Số tiền rút tối thiểu là \${min} ${MAIN_CREDIT_UNIT}.`,
  minAmountWithdrawCrypto: `Vui lòng rút tối thiểu \${min} ${MAIN_CREDIT_UNIT}.`,
  maxAmountWithDrawCrypto: `Vui lòng rút tối đa \${max} ${MAIN_CREDIT_UNIT}.`,
  maxAmountWithDraw: `Số tiền rút tối đa là \${max} ${MAIN_CREDIT_UNIT}.`,
  notEnoughBalance: 'Số dư của bạn không đủ.',
  minPassword: (value: number) => `Vui lòng không nhập ít hơn ${value} ký tự`,
  passwordNotMatch: 'Mật khẩu nhập lại chưa trùng khớp',
  noWhitespacePassword: 'Mật khẩu không được chứa khoảng trắng',
  newPasswordMustDiffer: 'Mật khẩu mới phải khác với mật khẩu cũ',
  usernameNoSpecialChars: 'Tên đăng nhập không chứa các ký tự đặc biệt',
  phoneNumberMustStartWithZero: 'Số điện thoại bắt đầu từ 0. Ví dụ: 0905123456',
  minLength: (value: number) => `Vui lòng không nhập ít hơn ${value} ký tự`,
  minLengthNumber: (value: number) =>
    `Vui lòng không nhập ít hơn ${value} chữ số`,
  userName: ({ min, max }: { min: number; max: number }) =>
    `Tên đăng nhập phải từ ${min} đến ${max} ký tự`,
} as const
